import { Cookies } from './cookies';

/**
 * Whether this is a frontend-canary session, detected via the `socrata_preview`
 * cookie the portal sets to `frontend-canary` (the same signal the site chrome
 * checks).
 */
export function isCanary(): boolean {
  return (Cookies.get('socrata_preview') ?? '').includes('frontend-canary');
}
